const response = await fetch('/config.json');
const config = await response.json();

const Config = {
    apiUrl: config.apiUrl,
    beta:   config.beta === true,
};

export default Config;